import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const HomeEdDashboardPage = lazy(() => import('src/pages/home-ed/dashboard'));
const HomeEdUnassignedPage = lazy(() => import('src/pages/home-ed/unassigned'));

// ----------------------------------------------------------------------

const guardedDashboard = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdDashboardPage />
  </RoleBasedGuard>
);

const guardedUnassigned = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdUnassignedPage />
  </RoleBasedGuard>
);

export const homeEdRoutes = [
  {
    path: 'home-ed',
    children: [
      { element: guardedDashboard, index: true },
      { path: 'unassigned', element: guardedUnassigned },
    ],
  },
];
